// Module
var code = "<div class=\"content-center\"> <img class=\"m-24px\" src=\"src/generic/icon/manage-striim/02-Metadata Manager-Cache-Empty.svg\" data-testid=\"not-selected-item\"/> <span class=\"not-selected-text\">Select a component from the list to view details</span> </div> ";
// Exports
export default code;